import clsx from "clsx"
import PropTypes from "prop-types"
import { useFormContext } from "react-hook-form"
import Spinner from "~/components/Common/Spinner"

const DocHeader = ({ onSubmitHandler, isLoading, doc }) => {
  const { watch, formState } = useFormContext() || {}
  const { isDirty } = formState || {}

  const name = watch ? watch("name") : doc.name
  return (
    <div className="bg-brand-secondary h-[140px] p-4">
      <div className="flex justify-between">
        <div className="w-[90%]">
          <h1 className="text-white text-lg md:text-[3rem] truncate">
            {name ?? doc.name}
          </h1>
          <h3 className="capitalize text-white">{doc.type}</h3>
        </div>
        <div>
          <button
            disabled={!isDirty || isLoading}
            className={clsx(
              "uppercase p-2 bg-primary text-white rounded-lg flex justify-center items-center w-[50px] h-[30px]",
              !isDirty && "opacity-50",
            )}
            onClick={onSubmitHandler}
          >
            {isLoading ? <Spinner color="white" height="10px" /> : "save"}
          </button>
        </div>
      </div>
    </div>
  )
}

DocHeader.propTypes = {
  doc: PropTypes.object,
  onSubmitHandler: PropTypes.func,
  isLoading: PropTypes.bool,
}

export default DocHeader
